<template>
  <div class="news_container">
    <div class="news_title">
      {{ newsDetail.title }}
    </div>
    <div class="description">
      {{ newsDetail.description }}
    </div>
    <div class="news_time">
      {{ newsDetail.operate_time || newsDetail.created_at }}
    </div>
    <div v-html="newsDetail.content" class="content">

    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      newsDetail: {
        created_at: "",
        operate_time: "",
        description: "",
        title: ""
      }
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    headerHeight() {
      return this.$store.state.headerHeight;
    }
  },
  methods: {
    getData() {
      let id = this.$route.params.id
      axios({
        url: "https://service.hengshui.tuoyupt.com/api/policy/science/sciencedetail?id=" + id,
      })
        .then(res => {
          return res.data.data;
        }).then(res => {
          console.log(res)
          this.newsDetail = res;
        })
    }
  },
};
</script>
<style lang="scss" scoped>
.news_title {
  font-size: 44px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  line-height: 60px;
}

.news_container {
  width: 100vw;
  box-sizing: border-box;
  padding: 40px 30px;
  background: #fff;
}

.news_time {
  margin-top: 18px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #AEB0BC;
  line-height: 44px;
  margin-bottom: 40px;
}

.description {
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #F6F6F6;
  font-size: 32px;
  margin: 20px 0;
}

.content {
  font-size: 32px;
}
</style>
